var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScopeCredWrite = function SvgScopeCredWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M14.667 7c0-.747 0-1.32-.146-1.605a1.33 1.33 0 0 0-.582-.583c-.286-.145-.659-.145-1.406-.145H3.467c-.747 0-1.12 0-1.406.145-.25.128-.454.332-.582.583-.146.285-.146.658-.146 1.405v2.4c0 .747 0 1.12.146 1.405.128.251.331.455.582.583.286.145.659.145 1.406.145H8.5M8 8h.003m3.33 0h.004m-6.67 0h.003m3.497 0a.167.167 0 1 1-.334 0 .167.167 0 0 1 .334 0M11.5 8a.167.167 0 1 1-.333 0 .167.167 0 0 1 .333 0M4.833 8A.167.167 0 1 1 4.5 8a.167.167 0 0 1 .333 0M9.117 13.95c.014-.129.021-.193.04-.253a.6.6 0 0 1 .073-.15c.035-.053.08-.099.172-.19l4.1-4.1a.878.878 0 1 1 1.24 1.242l-4.099 4.1a1.3 1.3 0 0 1-.19.171.6.6 0 0 1-.15.072c-.06.02-.124.027-.252.041L9 15z"
  })));
};
export default SvgScopeCredWrite;